<template>
  <div class="contract-page">
    <div class="contract-container">
    <div class="title-bg">近90份被删合同</div>
      <!-- 搜索区域 -->
      <v-card class="search-card">
        <v-card-text>
          <v-row class="align-center">
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="searchForm.keyword"
                label="关键字搜索"
                persistent-placeholder
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                hide-details
                density="compact"
                clearable
                class="search-input"
                placeholder="唯一码/项目名称/业务员"
                @keyup.enter="handleSearch"
                @click:clear="handleSearch"
              />
            </v-col>
            <!-- <v-col cols="12" sm="3">
              <v-select
                v-model="searchForm.statusPricing"
                :items="contractTypeListOptions"
                item-title="title"
                item-value="value"
                label="核价状态"
                variant="outlined"
                hide-details
                density="compact"
                clearable
                class="search-input"
              />
            </v-col> -->
            <v-col cols="12" sm="3">
              <div class="d-flex gap-2">
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="handleSearch"
                  class="search-btn"
                  density="comfortable"
                >
                  查询
                </v-btn>
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="handleReset"
                  class="search-btn"
                  density="comfortable"
                >
                  重置
                </v-btn>
              </div>
            </v-col>
            <!-- <v-col cols="12" sm="3">
              <div class="d-flex justify-end">
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="handleAdd"
                  class="search-btn"
                  density="comfortable"
                >
                  新增合同
                </v-btn>
              </div>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 表格区域 -->
      <v-card class="table-card">
        <v-card-text class="pa-0">
          <v-table class="contract-table" hover>
            <thead>
              <tr>
                <th v-for="header in headers" :key="header.key" :class="['text-' + header.align]" :style="{ width: header.width }">
                  <div class="align-center">
                    {{ header.title }}
                    <!-- <v-menu v-if="header.key === 'priceStatus'" location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn
                          icon="mdi-filter"
                          variant="text"
                          density="compact"
                          size="small"
                          v-bind="props"
                          :color="searchForm.statusPricing !== null ? 'primary' : undefined"
                        />
                      </template>
                      <v-card class="filter-menu">
                        <v-card-text class="pa-2">
                          <v-radio-group
                            v-model="searchForm.statusPricing"
                            density="compact"
                            class="filter-radio-group"
                            hide-details
                          >
                            <v-radio
                              label="全部"
                              :value="null"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                            <v-radio
                              v-for="option in contractTypeListOptions"
                              :key="option.value"
                              :label="option.title"
                              :value="option.value"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                          </v-radio-group>
                        </v-card-text>
                        <v-divider />
                      </v-card>
                    </v-menu> -->
                    <!-- <v-menu v-if="header.key === 'designStatus'" location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn
                          icon="mdi-filter"
                          variant="text"
                          density="compact"
                          size="small"
                          v-bind="props"
                          :color="searchForm.statusDesign !== null ? 'primary' : undefined"
                        />
                      </template>
                      <v-card class="filter-menu">
                        <v-card-text class="pa-2">
                          <v-radio-group
                            v-model="searchForm.statusDesign"
                            density="compact"
                            class="filter-radio-group"
                            hide-details
                          >
                            <v-radio
                              label="全部"
                              :value="null"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                            <v-radio
                              v-for="option in statusDesignListOptions"
                              :key="option.value"
                              :label="option.title"
                              :value="option.value"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                          </v-radio-group>
                        </v-card-text>
                        <v-divider />
                      </v-card>
                    </v-menu> -->
                    <!-- <v-menu v-if="header.key === 'materialStatus'" location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn
                          icon="mdi-filter"
                          variant="text"
                          density="compact"
                          size="small"
                          v-bind="props"
                          :color="searchForm.statusWuliao !== null ? 'primary' : undefined"
                        />
                      </template>
                      <v-card class="filter-menu">
                        <v-card-text class="pa-2">
                          <v-radio-group
                            v-model="searchForm.statusWuliao"
                            density="compact"
                            class="filter-radio-group"
                            hide-details
                          >
                            <v-radio
                              label="全部"
                              :value="null"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                            <v-radio
                              v-for="option in statusWuLiaoListOptions"
                              :key="option.value"
                              :label="option.title"
                              :value="option.value"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                          </v-radio-group>
                        </v-card-text>
                        <v-divider />
                      </v-card>
                    </v-menu> -->
                    <v-menu v-if="header.key === 'statusFinance'" location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn
                          icon="mdi-filter"
                          variant="text"
                          density="compact"
                          size="small"
                          v-bind="props"
                          :color="searchForm.statusFinance !== null ? 'primary' : undefined"
                        />
                      </template>
                      <v-card class="filter-menu">
                        <v-card-text class="pa-2">
                          <v-radio-group
                            v-model="searchForm.statusFinance"
                            density="compact"
                            class="filter-radio-group"
                            hide-details
                          >
                            <v-radio
                              label="全部"
                              :value="null"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                            <v-radio
                              v-for="option in statusFinanceListOptions"
                              :key="option.value"
                              :label="option.title"
                              :value="option.value"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                          </v-radio-group>
                        </v-card-text>
                        <v-divider />
                      </v-card>
                    </v-menu>
                    <v-menu v-if="header.key === 'statusGroup'" location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn
                          icon="mdi-filter"
                          variant="text"
                          density="compact"
                          size="small"
                          v-bind="props"
                          :color="searchForm.statusGroup !== null ? 'primary' : undefined"
                        />
                      </template>
                      <v-card class="filter-menu">
                        <v-card-text class="pa-2">
                          <v-radio-group
                            v-model="searchForm.statusGroup"
                            density="compact"
                            class="filter-radio-group"
                            hide-details
                          >
                            <v-radio
                              label="全部"
                              :value="null"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                            <v-radio
                              v-for="option in statusGroupListOptions"
                              :key="option.value"
                              :label="option.title"
                              :value="option.value"
                              color="#D2475D"
                              density="compact"
                              @change="handleSearch"
                            />
                          </v-radio-group>
                        </v-card-text>
                        <v-divider />
                      </v-card>
                    </v-menu>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading" class="text-center">
                <td :colspan="headers.length" class="py-8">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <div class="mt-2">加载中...</div>
                </td>
              </tr>
              <tr v-else-if="contractList.length === 0" class="text-center">
                <td :colspan="headers.length" class="py-8">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(item, index) in contractList" :key="index">
                  <td class="text-center">{{ item.uniqueCode || '-' }}</td>
                  <!-- <td class="text-center">{{ item.customerShortName || '-' }}</td> -->
                  <td class="text-center">{{ item.contractName || '-' }}</td>
                  <td class="text-center">
                    {{ item.pricingFinishCount }} / {{ item.pricingCount }}
                    <!-- <v-chip
                      :color="getStatusSpecialColor(item.priceStatus)"
                      size="small"
                      variant="flat"
                    >
                      {{ getPriceStatusText(item.priceStatus) }}
                    </v-chip> -->
                  </td>
                  <td class="text-center">
                    {{ item.designFinishCount }} / {{ item.designCount }}
                    <!-- <v-chip
                      :color="getPriceStatusColor(item.designStatus)"
                      size="small"
                      variant="flat"
                    >
                      {{ getDesignStatusText(item.designStatus) }}
                    </v-chip> -->
                  </td>
                  <td class="text-center">
                    {{ item.wuliaoFinishCount }} / {{ item.wuliaoCount }}
                    <!-- <v-chip
                      :color="getPriceStatusColor(item.materialStatus)"
                      size="small"
                      variant="flat"
                    >
                      {{ getWuLiaoStatusText(item.materialStatus) }}
                    </v-chip> -->
                  </td>
                  <td class="text-center">
                    <v-chip
                      :color="getPriceStatusColor(item.statusFinance)"
                      size="small"
                      variant="flat"
                    >
                      {{ getFinanceAuditStatusText(item.statusFinance) }}
                    </v-chip>
                  </td>
                  <!-- <td class="text-center">
                    <v-chip
                      :color="getPriceStatusColor(item.statusGroup)"
                      size="small"
                      variant="flat"
                    >
                      {{ getGroupAuditStatusText(item.statusGroup) }}
                    </v-chip>
                  </td> -->
                  <td class="text-center">{{ formatDate(item.createTime) }}</td>
                  <td class="text-center">
                    <v-btn
                      class="list-edit-btn"
                      style="margin-right: 8px;"
                      @click="handleEdit(item)"
                    >
                      编辑
                    </v-btn>
                    <v-btn
                      color="primary"
                      variant="flat"
                      size="small"
                      @click="handleRestore(item)"
                    >
                      恢复
                    </v-btn>
                  </td>
                </tr>
              </template>
            </tbody>
          </v-table>

          <!-- 分页区域 -->
          <div class="custom-pagination d-flex align-center justify-space-between">
            <div class="pagination-info">共 {{ total }} 条记录</div>
            
            <div class="d-flex align-center">
              <!-- <span class="items-per-page-text mr-2">每页项目数</span> -->
              <!-- <v-select
                v-model="pageSize"
                :items="[10, 20, 50, 100]"
                variant="outlined"
                density="compact"
                class="d-inline-flex page-size-select mr-4"
                style="width: 80px;"
                hide-details
              /> -->
              
              <div class="pagination-controls">
                <v-btn
                  icon="mdi-chevron-double-left"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === 1"
                  @click="currentPage = 1"
                  class="pagination-btn"
                />
                <v-btn
                  icon="mdi-chevron-left"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === 1"
                  @click="currentPage--"
                  class="pagination-btn"
                />
                <span class="pagination-text mx-2">{{ currentPage }} / {{ totalPages }}</span>
                <v-btn
                  icon="mdi-chevron-right"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === totalPages"
                  @click="currentPage++"
                  class="pagination-btn"
                />
                <v-btn
                  icon="mdi-chevron-double-right"
                  variant="text"
                  density="comfortable"
                  :disabled="currentPage === totalPages"
                  @click="currentPage = totalPages"
                  class="pagination-btn"
                />
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- 删除确认对话框 -->
      <v-dialog v-model="deleteDialog" max-width="400">
        <v-card class="delete-dialog">
          <v-card-title class="text-h5">
            确认恢复
          </v-card-title>
          <v-card-text>
            确定要恢复合同 "{{ selectedContract?.uniqueCode }}" 吗？
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              variant="tonal"
              @click="deleteDialog = false"
            >
              取消
            </v-btn>
            <v-btn
              color="primary"
              variant="flat"
              @click="confirmRestore"
              :loading="deleteLoading"
            >
              确认恢复
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import { useRouter } from 'vue-router'
import DateInput from '@/components/DateInput.vue'
import { contractApi } from '@/services/api'
import { contractTypeListOptions,statusDesignListOptions,designStatusListOptions,statusWuLiaoListOptions,statusAuditListOptions,statusFinanceListOptions,statusGroupListOptions } from '@/constants/contract'

interface Contract {
  id?: number
  contractNo: string
  uniqueCode: string
  contractName: string
  partyName: string
  customerShortName: string
  projectType: string
  salesmanName: string
  priceStatus: number
  designStatus: number
  materialStatus: number
  auditStatus: number
  statusFinance: number
  statusGroup: number
  productionStatus: number
  region: string
  createTime: string
  pricingName: string
  pricingTime: string
  remarks: string
  pricingFinishCount: number
  pricingCount: number
  designFinishCount: number
  designCount: number
  wuliaoFinishCount: number
  wuliaoCount: number
}

interface ApiResponse {
  code: number
  message: string
  data: any
}

interface SearchForm {
  keyword: string
  statusPricing: number | null
  statusDesign: number | null
  statusWuliao: number | null
  statusFinance: number | null
  statusGroup: number | null
}

const { showSuccess, showError } = useSnackbar()
const router = useRouter()

// 表格列配置
const headers = [
  { title: '合同唯一码', key: 'uniqueCode', align: 'center',width: '120px' },
  // { title: '客户简称', key: 'customerShortName', align: 'center',width: '140px' },
  { title: '项目名称', key: 'contractName', align: 'center',width: '240px' },
  { title: '核价状态', key: 'priceStatus', align: 'center',width: '110px' },
  { title: '设计状态', key: 'designStatus', align: 'center',width: '110px' },
  { title: '物控状态', key: 'materialStatus', align: 'center',width: '110px' },
  // { title: '审核状态', key: 'auditStatus', align: 'center' },
  { title: '财务状态', key: 'statusFinance', align: 'center',width: '110px' },
  // { title: '集团状态', key: 'statusGroup', align: 'center',width: '110px' },
  // { title: '生产状态', key: 'productionStatus', align: 'center' },
  { title: '创建时间', key: 'createTime', align: 'center',width: '140px' },
  { title: '操作', key: 'actions', align: 'center', sortable: false,width: '120px' }
]

// 响应式数据
const loading = ref(false)
const currentPage = ref(1)
const pageSize = ref(30)
const total = ref(0)
const contractList = ref<Contract[]>([])
const searchForm = ref<SearchForm>({
  keyword: '',
  statusPricing: null,
  statusDesign: null,
  statusWuliao: null,
  statusFinance: null,
  statusGroup: null
})

// 计算属性
const totalPages = computed(() => Math.ceil(total.value / pageSize.value))

// 删除相关状态
const deleteDialog = ref(false)
const deleteLoading = ref(false)
const selectedContract = ref<Contract | null>(null)

// 方法
const handleSearch = () => {
  currentPage.value = 1
  loadContractList()
}

const handleReset = () => {
  searchForm.value = {
    keyword: '',
    statusPricing: null,
    statusDesign: null,
    statusWuliao: null,
    statusFinance: null,
    statusGroup: null
  }
  handleSearch()
}

const handleEdit = (item: Contract) => {
  sessionStorage.removeItem('title')
  sessionStorage.removeItem('currentProductPage')
  sessionStorage.removeItem('currentMaterialPage')
  // router.push({
  //   path: '/newContract',
  //   query: {
  //     id: item.id,
  //     mode: 'edit',
  //     identity: 'sales'
  //   }
  // })
  const url = `/newContract?mode=edit&identity=sales&id=${item.id}`
  window.open(url, '_blank')
}

const handleRestore = (item: Contract) => {
  selectedContract.value = item
  deleteDialog.value = true
}

const confirmRestore = async () => {
  if (!selectedContract.value) return
  
  try {
    deleteLoading.value = true
    const res = await contractApi.restoreContract({
      id: selectedContract.value.id
    })
    if(res.code === 0){
      showSuccess('恢复成功')
    }else{
      showError(res.message || res.msg)
    }
    deleteDialog.value = false
    loadContractList()
  } catch (error) {
    showError(error.message || error.msg)
  } finally {
    deleteLoading.value = false
    selectedContract.value = null
  }
}

const handleAdd = async () => {
  sessionStorage.removeItem('title')
  sessionStorage.removeItem('currentProductPage')
  sessionStorage.removeItem('currentMaterialPage')
  const submitData = {
    submit: 0
  }
  try {
    const res = (await contractApi.addOrUpdate(submitData as any)) as unknown as ApiResponse
    if(res.code === 0){
      // showSuccess('提交成功')
      router.push('/newContract?mode=edit&identity=sales&id=' + res.data.id)
  }else{
      showError(res.message || '提交失败')
    }
  } catch (error: any) {
    showError(error.message || '提交失败')
  }
}

const loadContractList = async () => {
  try {
    loading.value = true
    // 构建请求参数
    const params = {
      page: currentPage.value,
      pageSize: pageSize.value,
      keyword: searchForm.value.keyword,
      statusPricing: searchForm.value.statusPricing,
      statusDesign: searchForm.value.statusDesign,
      statusWuliao: searchForm.value.statusWuliao,
      statusFinance: searchForm.value.statusFinance,
      statusGroup: searchForm.value.statusGroup,
      isDelete: 1
    }
    
    const res = await contractApi.getList(params) as unknown as ApiResponse
    console.log(res)
    if (res.code === 0) {
      // 处理API返回的数据
      contractList.value = res.data.records.map((contract: any) => ({
        id: contract.id,
        uniqueCode: contract.code || '-',
        contractName: contract.project || '-',
        partyName: contract.companyName || '-',
        customerShortName: contract.customerShortName || '-',
        projectType: contract.projectType || '-',
        salesmanName: contract.salesmanName || '-',
        priceStatus: Number(contract.statusPricing || 0),
        designStatus: Number(contract.statusDesign || 0),
        materialStatus: Number(contract.statusWuliao || 0),
        statusFinance: Number(contract.statusFinance || 0),
        statusGroup: Number(contract.statusGroup || 0),
        productionStatus: Number(contract.statusProduction || 0),
        region: contract.province + ' ' + contract.region || '-',
        createTime: contract.createTime,
        pricingName: contract.pricingName || '-',
        pricingTime: contract.pricingTime,
        remarks: contract.description || '-',
        pricingFinishCount: contract.pricingFinishCount || '-',
        pricingCount: contract.pricingCount || '-',
        designFinishCount: contract.designFinishCount || '-',
        designCount: contract.designCount || '-',
        wuliaoFinishCount: contract.wuliaoFinishCount || '-',
        wuliaoCount: contract.wuliaoCount || '-'
      }))
      total.value = res.data.total
    } else {
      showError(res.message || '获取数据失败')
    }
  } catch (error: any) {
    console.error('获取合同列表失败:', error)
    showError(error.message || '获取数据失败')
  } finally {
    loading.value = false
  }
}

// 格式化方法
const formatAmount = (amount: number) => {
  return amount.toLocaleString('zh-CN', {
    style: 'currency',
    currency: 'CNY'
  })
}

const formatDate = (date: string) => {
  if (!date) return '-'
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  return `${year}/${month}/${day} ${hours}:${minutes}`
}

const getStatusSpecialColor = (status: number) => {
  const colorMap: Record<number, string> = {
    0: 'status-default',
    1: 'status-waiting',
    2: 'status-process',
    3: 'status-success'
  }
  return colorMap[status] || 'status-default'
}

const getPriceStatusColor = (status: number) => {
  const colorMap: Record<number, string> = {
    0: 'status-default',
    1: 'status-process',
    2: 'status-success',
    3: 'status-process'
  }
  return colorMap[status] || 'status-default'
}

const getPriceStatusText = (status: number) => {
  const option = contractTypeListOptions.find(opt => opt.value === status)
  return option?.title || '-'
}

const getDesignStatusText = (status: number) => {
  const option = statusDesignListOptions.find(opt => opt.value === status)
  return option?.title || '-'
}

const getWuLiaoStatusText = (status: number) => {
  const option = statusWuLiaoListOptions.find(opt => opt.value === status)
  return option?.title || '-'
}

const getFinanceAuditStatusText = (status: number) => {
  const option = statusAuditListOptions.find(opt => opt.value === status)
  if(status === 0){
    return '未转财务'
  }else{
    return '财务' + option?.title
  }
}

const getGroupAuditStatusText = (status: number) => {
  const option = statusAuditListOptions.find(opt => opt.value === status)
  if(status === 0){
    return '未转集团'
  }else{
    return '集团' + option?.title
  }
}

// 监听分页变化
watch([currentPage, pageSize], () => {
  window.scrollTo(0, 0)
  loadContractList()
})

// 初始化
onMounted(() => {
  loadContractList()
})
</script>

<style scoped>
.search-input :deep(.mdi-magnify),
.search-input :deep(.mdi-magnify::before),
.search-input :deep(.mdi-close::before),
.search-input :deep(.mdi-close-circle),
.search-input :deep(.mdi-close) {
  color: #fff!important;
}

.contract-page {
  min-height: 100vh;
  width: 100%;
  background-color: #2B2D33;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 16px;
}

.contract-container {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.text-primary {
  color: #D2475D !important;
}

.search-card {
  background-color: #2B2D33 !important;
  border: none !important;
  position: relative;
  z-index: 20;
}

.search-card :deep(.v-text-field) .v-field__input,
.search-card :deep(.v-text-field) .v-field__field,
.search-card :deep(.v-text-field) input,
.search-card :deep(.v-autocomplete) .v-field__input,
.search-card :deep(.v-autocomplete) .v-field__field,
.search-card :deep(.v-autocomplete) input,
.search-card :deep(.v-select) .v-field__input,
.search-card :deep(.v-select) .v-field__field,
.search-card :deep(.v-select) input,
.search-card :deep(.v-select) .v-select__selection-text,
.search-card :deep(.v-select) .v-select__selection,
.search-card :deep(.v-text-field) .v-field__append-inner,
.search-card :deep(.v-autocomplete) .v-field__append-inner,
.search-card :deep(.v-select) .v-field__append-inner {
  color: #fff !important;
}

.search-card :deep(.v-text-field) .v-field__outline,
.search-card :deep(.v-autocomplete) .v-field__outline,
.search-card :deep(.v-select) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

.search-card :deep(.v-text-field) .v-field__input::placeholder,
.search-card :deep(.v-autocomplete) .v-field__input::placeholder,
.search-card :deep(.v-select) .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

.search-card :deep(.v-text-field) .v-label,
.search-card :deep(.v-autocomplete) .v-label,
.search-card :deep(.v-select) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

.search-card :deep(.v-text-field) .v-field__append-inner i,
.search-card :deep(.v-autocomplete) .v-field__append-inner i,
.search-card :deep(.v-select) .v-field__append-inner i {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-card) {
  box-shadow: none !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.table-card {
  background-color: #2B2D33 !important;
  flex: 1;
  display: flex;
  position: relative;
  z-index: 1;
}

.table-card :deep(.v-card-text) {
  padding: 16px;
}

.table-card :deep(.v-col) {
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  justify-content: center;
}

.table-card .search-btn {
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  font-size: 14px;
  padding: 0 8px;
  min-width: unset;
}

.contract-table{
  background-color: #2B2D33;
}

.contract-table :deep(th) {
  background-color: #2B2D33 !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.contract-table :deep(td) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.contract-table :deep(tr:hover) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.custom-pagination {
  padding: 16px;
  color: rgba(255, 255, 255, 0.7);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.custom-pagination .pagination-info {
  font-size: 14px;
}

.custom-pagination .items-per-page-text {
  font-size: 14px;
}

.custom-pagination .page-size-select :deep(.v-field__input) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.custom-pagination .pagination-controls {
  display: flex;
  align-items: center;
}

.custom-pagination .pagination-btn {
  color: rgba(255, 255, 255, 0.7) !important;
}

.custom-pagination .pagination-btn:hover {
  color: #fff !important;
}

.custom-pagination .pagination-btn:disabled {
  color: rgba(255, 255, 255, 0.3) !important;
}

.custom-pagination .pagination-text {
  font-size: 14px;
}

.search-input {
  width: 100%;
}

.gap-2 {
  gap: 8px;
}

.search-btn {
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  font-size: 14px;
  padding: 0 16px;
  min-width: unset;
}

.delete-dialog {
  background-color: #2B2D33 !important;
}

.delete-dialog :deep(.v-card-title) {
  color: #fff !important;
}

.delete-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.delete-dialog :deep(.v-btn) {
  text-transform: none;
  letter-spacing: 0;
}

.v-chip--density-default.bg-default{
  /* background: transparent !important; */
}

.filter-menu {
  background-color: #2B2D33 !important;
}

.filter-menu :deep(.v-radio-group) {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-menu :deep(.v-radio) {
  min-height: 28px;
  padding: 0;
}

.filter-menu :deep(.v-radio .v-label) {
  font-size: 13px;
  opacity: 0.9;
}

.filter-menu :deep(.v-selection-control) {
  min-height: 28px;
}

.filter-menu :deep(.v-selection-control__wrapper) {
  width: 28px;
  height: 28px;
}

.filter-menu :deep(.v-radio-group .v-selection-control__input > i) {
  color: #D2475D !important;
  font-size: 16px;
}

.filter-menu :deep(.v-radio-group .v-selection-control--dirty .v-selection-control__input > i) {
  opacity: 1;
}

.filter-menu :deep(.v-card-text.pa-2) {
  background-color: #fff !important;
  width: 100px;
}

.bg-status-default{
  border-radius: 4px;
  background-color: #3b3b3b !important;
}

.bg-status-process{
  border-radius: 4px;
  background-color: #453237 !important;
  color: rgb(var(--v-theme-error)) !important;;
}

.bg-status-success{
  border-radius: 4px;
  background-color: #3B4D3E !important;
  color: #66BB6A !important;
}

:deep(th),:deep(td) {
  padding: 0!important;
}
</style> 